module.exports = __webpack_public_path__ + "img/icon-error.8d08e9da.svg";